import {
  Box,
  createStyles,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core';
import Loading from 'components/Modal/__LEGACY__/AbrirVotacaoPautaModal/Loading';
import React from 'react';

export interface ILoadingScreen {
  label?: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    loadingContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignContent: 'center',
      width: '100%',
      height: '100vh',
      padding: theme.spacing(),
      boxSizing: 'border-box',
    },
    loading: {
      alignSelf: 'center',
    },
    label: {
      textAlign: 'center',
      marginTop: '15px',
    },
  })
);

export default function LoadingScreen({ label }: ILoadingScreen) {
  const classes = useStyles();

  return (
    <Box className={classes.loadingContainer}>
      <Loading />
      {label ? (
        <Typography className={classes.label}>{label}</Typography>
      ) : null}
    </Box>
  );
}
